import React, { useState, useContext } from 'react';
import { Button, Form, FormGroup, Label, Input, Col } from 'reactstrap';
import Alert from 'react-s-alert';
import PsychometricService from '../../services/PsychometricService';
// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import ErrorBoundary from '../general/ErrorBoundary';

const AddOrganization = () => {
    
    const { theme } = useContext(ThemeContext);
    const [organization, setOrganization] = useState({
        name: '',
        email: '',
        mobile: '',
        address: '',
        city: '',
        state: '',
        country: '',
        logo: '',
        website: '',
        password: ''
    });

    const handleChange = e => {
        setOrganization({ ...organization, [e.target.name]: e.target.value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await PsychometricService.createOrganization(
                organization.name,
                organization.email,
                organization.mobile,
                organization.address,
                organization.city,
                organization.state,
                organization.country,
                organization.logo,
                organization.website,
                organization.password
            );
            Alert.success(`Organization  added successfully!`, {
                position: 'top-right',
                effect: 'slide'
            });
            // Reset form
            setOrganization({
                name: '',
                email: '',
                mobile: '',
                address: '',
                city: '',
                state: '',
                country: '',
                logo: '',
                website: '',
                password:''
            });
        } catch (error) {
            console.error('Error adding organization:', error);
            let errorMessage = 'An unexpected error occurred while adding the organization.';
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                errorMessage = `Server error: ${error.response.status} - ${error.response.data.message || error.response.statusText}`;
            } else if (error.request) {
                // The request was made but no response was received
                errorMessage = 'No response received from the server. Please check your network connection.';
            } else {
                // Something happened in setting up the request that triggered an Error
                errorMessage = error.message;
            }
            Alert.error(`Error adding organization: ${errorMessage}`, {
                position: 'top-right',
                effect: 'slide',
                timeout: 5000
            });
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">Add Organization</h3>
                <div className="card mb-4">
                    <div className="card-header">
                        Create a new Organization
                    </div>
                    <div className="card-body">
                        <ErrorBoundary errorAt="At Admin AddOrganization Form">
                            <Form onSubmit={handleSubmit}>
                                <FormGroup row>
                                    <Label sm={2} for="name">Name</Label>
                                    <Col sm={10}>
                                        <Input type="text" name="name" id="name" value={organization.name} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2} for="email">Email</Label>
                                    <Col sm={10}>
                                        <Input type="email" name="email" id="email" value={organization.email} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2} for="mobile">Mobile</Label>
                                    <Col sm={10}>
                                        <Input type="text" name="mobile" id="mobile" value={organization.mobile} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2} for="address">Address</Label>
                                    <Col sm={10}>
                                        <Input type="text" name="address" id="address" value={organization.address} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2} for="city">City</Label>
                                    <Col sm={10}>
                                        <Input type="text" name="city" id="city" value={organization.city} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2} for="state">State</Label>
                                    <Col sm={10}>
                                        <Input type="text" name="state" id="state" value={organization.state} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2} for="country">Country</Label>
                                    <Col sm={10}>
                                        <Input type="text" name="country" id="country" value={organization.country} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2} for="website">Website</Label>
                                    <Col sm={10}>
                                        <Input type="text" name="website" id="website" value={organization.website} onChange={handleChange} />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2} for="website">Temporary Password</Label>
                                    <Col sm={10}>
                                        <Input type="text" name="password" id="passowrd" value={organization.password} onChange={handleChange} />
                                    </Col>
                                </FormGroup>
                                <Button type="submit" className="btn mt-2" style={theme.button} color="primary">Add Organization</Button>
                            </Form>
                        </ErrorBoundary>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default AddOrganization;
